import {useState, useEffect} from "react";
import isEmpty from "lodash/isEmpty";
import useLocalStorageModule from "use-local-storage";
const useLocalStorage = useLocalStorageModule.default ?? useLocalStorageModule;
export const useHandleFrequency = (selectedOs) => {
  const [selectedFrequencyCache, setSelectedFrequencyCache] = useLocalStorage(
    "selectedFrequencyCache",
    undefined
  );
  const [selectedFrequency, setSelectedFrequency] = useState(selectedFrequencyCache);
  const [frequencyOptions, setFrequencyOptions] = useState([]);

  useEffect(() => {
    const newFrequencyOptions = selectedOs?.frequencies;

    if (isEmpty(newFrequencyOptions)) {
      setSelectedFrequency(undefined);
      setSelectedFrequencyCache(undefined);
      setFrequencyOptions([]);
    } else {
      setFrequencyOptions(newFrequencyOptions);

      // check if selectedFrequencyCache is in newFrequencyOptions
      const index = newFrequencyOptions.findIndex(
        (option) => option.value === selectedFrequencyCache?.value
      );
      if (index === -1) {
        // if not, set selectedFrequency to first option and selectedFrequencyCache to first option
        const newFrequency = newFrequencyOptions[0] || {};
        setSelectedFrequency(newFrequency);
        setSelectedFrequencyCache(newFrequency);
      } else {
        // if it is, set selectedFrequency to selectedFrequencyCache
        setSelectedFrequency(selectedFrequencyCache);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFrequencyCache, selectedOs]);

  const handleFrequencyChange = (frequency) => {
    const selectedFrequencyOption = frequencyOptions.find(
      (option) => option.value === frequency.value
    );
    const newFrequency = selectedFrequencyOption || frequencyOptions[0] || {};
    setSelectedFrequency(newFrequency);
    setSelectedFrequencyCache(newFrequency);
  };

  return {
    frequencyOptions,
    handleFrequencyChange,
    selectedFrequency,
  };
};
